<template>
  <Header></Header>
  <el-container class="layout-container">
    <router-view></router-view>
    <!-- <HomeView></HomeView> -->
  </el-container>
</template>

<script>
// import HomeView from '@/views/HomeView.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'App',
  components: {
    // HomeView,
    Header
  },
  mounted () {
    this.toView('/main')
  },
  methods: {
    toView (path) {
      this.$router.push(path)
      console.log(path)
    }
  }
}

</script>

<style scoped>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.layout-container {
  margin: 0 auto;
  width: 100%;
  height: 89vh;
}
</style>
